import React from 'react';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import cn from 'classnames';
import { useFreeformSquareSizing } from '../helpers';
import EditorDeviationLink from '../_partials/DeviationLink';
import DumbView from '../../../DeviationViews/Dumbo/EditorDumbo';
import s from './Commission.scss';
const CommissionMonoView = (props)=>{
    const containerSize = useEditorContainerSize();
    const { deviation, extOptions, width: propsWidth, link } = props;
    const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root']),
        style: {
            width: size.width
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(DumbView, {
        width: size.width,
        height: size.height,
        deviation: deviation
    })));
};
CommissionMonoView.displayName = 'CommissionMonoView';
export default CommissionMonoView;

//# sourceMappingURL=Commission.js.map